import groq from "groq";
import { getClient } from "../sanity";
import { type BlogSimple, blogSimpleFragment } from "./blogs";
import { type Customer, customerFragment } from "./customers";

export type Banner = {
  title: string;
  description: string;
  ctaLink: string;
};

type SiteSettings = {
  announcementBanner?: Banner;
  defaultFeaturedBlogs?: BlogSimple[];
  b2cLogos?: Customer[];
  b2bLogos?: Customer[];
};

export const getAnnouncementBanner = async (): Promise<Banner | undefined> => {
  const query = groq`
    *[_type == "siteSettings"][0] {
      announcementBanner->{title, description, ctaLink},
    }
  `;
  const siteSettings = await getClient().fetch<SiteSettings | undefined>(query);
  return siteSettings?.announcementBanner;
};

export const getDefaultBlogs = async (): Promise<BlogSimple[]> => {
  const query = groq`
    *[_type == "siteSettings"][0] {
      defaultFeaturedBlogs[]->{ ${blogSimpleFragment} },
    }
  `;
  const siteSettings = await getClient().fetch<SiteSettings | undefined>(query);
  return siteSettings?.defaultFeaturedBlogs ?? [];
};

export const getStackedLogos = async (): Promise<Customer[][]> => {
  const query = groq`
    *[_type == "siteSettings"][0] {
      b2cLogos[]->{ ${customerFragment} },
      b2bLogos[]->{ ${customerFragment} },
    }
  `;
  const siteSettings = await getClient().fetch<SiteSettings | undefined>(query);
  const b2cLogos = siteSettings?.b2cLogos ?? [];
  const b2bLogos = siteSettings?.b2bLogos ?? [];
  return [b2cLogos, b2bLogos];
};
